import { render, staticRenderFns } from "./TemplateDetailNormal.vue?vue&type=template&id=7f94079a&scoped=true&"
import script from "./TemplateDetailNormal.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailNormal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailNormal.vue?vue&type=style&index=0&id=7f94079a&scoped=true&lang=css&"
import style1 from "./TemplateDetailNormal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94079a",
  null
  
)

export default component.exports